export const cutText = (input, width) => {
  if (input) {
    return input.length > width ? input.substring(0, width - 3) + '...' : input;
  } else {
    return null;
  }
};
